import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function OwnershipControl({ asset, isOperator, onSave }) {
  const [confirming, setConfirming] = useState(false);
  const [endedOn, setEndedOn] = useState("");
  const previouslyOwned = asset?.ownership_status === "former";

  const handleChange = () => {
    if (previouslyOwned) {
      onSave({ ownership_status: "owned" });
      setConfirming(false);
      setEndedOn("");
      return;
    }
    setConfirming(true);
  };

  const handleConfirm = () => {
    if (!endedOn) return;
    onSave({ ownership_status: "former", ownership_ended_on: endedOn });
    setConfirming(false);
    setEndedOn("");
  };

  const handleCancel = () => {
    setConfirming(false);
    setEndedOn("");
  };

  return (
    <div className="mt-3 space-y-3">
      <div data-testid="ownership-state" className="text-sm font-semibold text-foreground">
        {previouslyOwned ? `Previously owned${asset?.ownership_ended_on ? ` since ${asset.ownership_ended_on}` : ""}` : "Owned"}
      </div>

      {isOperator && (
        <div className="space-y-3">
          <Button data-testid="ownership-change-button" size="sm" variant="outline" onClick={handleChange} className="rounded-sm">
            {previouslyOwned ? "Mark owned" : "Mark previously owned"}
          </Button>

          {confirming && !previouslyOwned && (
            <div className="rounded-sm border border-border bg-card p-3 space-y-3 max-w-md">
              <p data-testid="ownership-consequence" className="text-sm text-muted-foreground">
                This property stops counting toward portfolio value, holdings count, and net worth.
              </p>
              <Input
                data-testid="ownership-date-input"
                type="date"
                value={endedOn}
                onChange={(e) => setEndedOn(e.target.value)}
                className="rounded-sm h-9 w-44"
              />
              <div className="flex items-center gap-2">
                <Button data-testid="ownership-confirm-button" size="sm" onClick={handleConfirm} className="rounded-sm">
                  Confirm
                </Button>
                <Button data-testid="ownership-cancel-button" size="sm" variant="outline" onClick={handleCancel} className="rounded-sm">
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
